import React from 'react';

function WelcomeFlagShip() {
  return (
    <div className="text-container flagship-copy-wrapper">
      <h1>AMSALE SoHo Flagship</h1>
      <p>
        {/* eslint-disable-next-line max-len */}
        Welcome to our NYC Flagship at 150 Wooster Street, SoHo. From brides and bridesmaids to mothers of the bride/groom, wedding guests, and more, we’re excited to help curate the perfect look for all special celebrations.
      </p>
      <br />
      <p>
        Please note that a $50 fee is required to reserve your appointment. The fee is a hold on your credit card and will be released after your visit.
        If you need to change or cancel your appointment, we kindly ask that you do so with at least 24 hours’ notice to avoid forfeiting the deposit.
      </p>
      <br />
      <p>
        To explore our Ready-to-Wear and Little White Dress collections, we recommend making an appointment for a guaranteed one-on-one experience. However, walk-in clients are also welcome.
      </p>
      <br />
      <p>
        Store Hours:
        <br />
        Tues–Fri 11–6 | Sat 9–5:30 | Sun 10–4:30
      </p>
      <br />
      <p>
        Available languages:
        <br />English, French, German, Mandarin, Russian, Spanish, Ukrainian
      </p>
      <br />
      <p>Unable to visit our NYC Flagship? <a href="https://wwdb.amsale.com/apps/wedding_wardrobe/booking/virtual-appointment">Click here</a> to book a Virtual Appointment.</p>
    </div>
  );
}

export default WelcomeFlagShip;
